import {
  requiredValidator,
  minLengthValidator,
  maxLengthValidator,
  numberValidator,
  decimalValidator,
  currencyValidator,
  usPhoneNumberValidator,
  socialSecurityNumberValidator,
  emailFormatValidator,
  optionalValidator,
  creditCardValidator,
  dateRequiredValidator,
  dateFormatValidator,
  dateRangeValidator,
  timeFormatValidator
} from '@cvent/nucleus-form-validations';
if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable-next-line */
  /* eslint-disable no-console */
  console.warn(
    [
      "DEPRECATED: 'nucleus-widgets/utils/validators.js' is now deprecated",
      'and will be removed in the next major version of nucleus-widgets.',
      "Please use '@cvent/nucleus-form-validations' instead."
    ].join(' ')
  );
  /* eslint-enable no-console */
}
export {
  requiredValidator,
  minLengthValidator,
  maxLengthValidator,
  numberValidator,
  decimalValidator,
  currencyValidator,
  usPhoneNumberValidator,
  socialSecurityNumberValidator,
  emailFormatValidator,
  optionalValidator,
  creditCardValidator,
  dateRequiredValidator,
  dateFormatValidator,
  dateRangeValidator,
  timeFormatValidator
};
